export default defineNuxtRouteMiddleware((to) => {
  if (to.path === "/maintainance") return;
  if (to.path.startsWith("/v2-owner-report-mobile")) return;

  const watchFeatureBlock = useWatchFeatureBlock();
  watchFeatureBlock.startWatching();

  if (watchFeatureBlock.isPathBlocked(to.path)) {
    return navigateTo("/maintainance");
  }
});
